import type { CSSProperties } from 'react';

const SvgIcon = ({
  iconPath,
  color,
  boxWidth,
  boxHeight,
  size = '19',
  style,
  additionalSvgProps,
  strokeColor,
  strokeWidth,
}: {
  iconPath: string;
  color: string;
  size?: number | string;
  boxWidth?: number | string;
  boxHeight?: number | string;
  style?: CSSProperties;
  additionalSvgProps?: Record<any, string>;
  strokeWidth?: number | string;
  strokeColor?: string;
}) => {
  return (
    <div style={style}>
      <svg
        {...additionalSvgProps}
        width={size}
        height={size}
        viewBox={`0 0 ${boxWidth ?? size} ${boxHeight ?? size}`}
        fill={color}
        strokeWidth={strokeWidth}
        stroke={strokeColor}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d={iconPath} />
      </svg>
    </div>
  );
};

export default SvgIcon;
